import React, {useEffect, useRef} from "react"

import YoutubeLiveInfo from "./YoutubeLiveInfo"
import iconClosed from "../../../../@shared/assets/images/icon-closed.png";
import {useSetIsMiniPlayerEnabled} from "../../../contexts/miniPlayer";


const YouTubeContent = ({
                          parentRef,
                        }: {
  parentRef: React.RefObject<HTMLDivElement>
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const liveUrl = "https://www.wowtv.co.kr/ExportHTS/Index?popForm=STOCK"
  const handleMiniPlayer = useSetIsMiniPlayerEnabled()


  const [iframeHeight, setIframeHeight] = React.useState(315)

  useEffect(() => {
    const resize = () => {
      if (parentRef.current) {
        const halfHeight = parentRef.current.offsetHeight / 2
        if (halfHeight > 315) {
          setIframeHeight(halfHeight)
        }
      }
    }

    window.addEventListener("resize", resize)
    resize()
  }, [parentRef.current?.clientHeight, parentRef.current?.clientWidth])

  const handleClickCloseChart = () => {
    handleMiniPlayer.inactive()
  }

  const handleClickLinktoLive = () => {
    window.open(liveUrl, "_blank")
  }

  return (
    <div className="youtubeContentWrapper" ref={ref}>
      <div className="title" onClick={handleClickLinktoLive}
           style={{cursor: "pointer"}}>
        한국경제TV 생방송
      </div>
      <div className='closeBtnWrapper'>
        <div
          onClick={handleClickCloseChart}
          className='closeBtn'>
          <img src={iconClosed} width={18}/>
        </div>
      </div>
      <div className="youtubePlayer">
        <iframe
          width={(iframeHeight * 16) / 9}
          height={iframeHeight}
          src={`${liveUrl}?autoplay=1`}
          frameBorder="0"
          allow="autoplay"
          allowFullScreen
        ></iframe>
      </div>
      <YoutubeLiveInfo/>
    </div>
  )
}

export default YouTubeContent
